import { Flex, Icon } from '@qga/roo-ui/components';

import Heading from '@/components/Heading';
import Text from '@/components/Text';

export type RoomTypeProps = {
  name: string;
  maxOccupants?: number;
};

const RoomType = ({ name, maxOccupants }: RoomTypeProps) => {
  return (
    <Flex flexDirection="column" justifyContent="space-evenly">
      <Heading.h6>{name}</Heading.h6>
      {maxOccupants && (
        <Flex flexDirection="row" alignItems="center">
          <Icon name="person" size="12px" color="icon.inclusion" />
          <Text ml="6px">Sleeps {maxOccupants}</Text>
        </Flex>
      )}
    </Flex>
  );
};

export default RoomType;
